export function evaluatePasswordStrength(password) {
    let score = 0;

    // Length criteria
    if (password.length >= 8) score += 20; // Length of at least 8
    if (password.length >= 12) score += 20; // Length of at least 12
    if (password.length >= 16) score += 20; // Length of at least 16

    // Character variety criteria
    if (/[a-z]/.test(password)) score += 15; // Lowercase letters
    if (/[A-Z]/.test(password)) score += 15; // Uppercase letters
    if (/[0-9]/.test(password)) score += 15; // Numbers
    if (/[\W_]/.test(password)) score += 20; // Special characters

    // Bonus for using a mix of character types
    const uniqueChars = new Set(password);
    if (uniqueChars.size > 10) score += 10; // More than 10 unique characters

    // Cap the score at 100
    return Math.min(score, 100);
}

// Example usage
// const password = "StrongP@ssw0rd!";
// const strengthScore = evaluatePasswordStrength(password);
// console.log(`Password Strength Score: ${strengthScore}`);


export function generateStrongPassword(length = 12) {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specialCharacters = "!@#$%^&*()_+[]{}|;:,.<>?";
    
    const allCharacters = uppercase + lowercase + numbers + specialCharacters;
    let password = "";

    // Ensure the password contains at least one character from each category
    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += specialCharacters[Math.floor(Math.random() * specialCharacters.length)];

    // Fill the rest of the password length with random characters
    for (let i = 4; i < length; i++) {
        password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
    }

    // Shuffle the password to avoid predictable patterns
    password = password.split('').sort(() => 0.5 - Math.random()).join('');

    return password;
}

// Example usage:
// const passwordLength = 12; // Specify the desired length
// const strongPassword = generateStrongPassword(passwordLength);
// console.log(strongPassword);
